interface ConfigFieldsProps {
  type: string;
  config: Record<string, any>;
  onChange: (config: Record<string, any>) => void;
  isEditing?: boolean;
}

export function IntegrationConfigFields({ type, config, onChange, isEditing }: ConfigFieldsProps) {
  function set(key: string, value: string) {
    onChange({ ...config, [key]: value });
  }

  if (type === 'DOCUGEN' || type === 'WISEJUS') {
    const isWisejus = type === 'WISEJUS';
    const productLabel = isWisejus ? 'WiseJus' : 'DocuGen';
    const baseUrlPlaceholder = isWisejus ? 'https://wisejus.com.br' : 'https://docugen.dev';
    const apiKeyPlaceholder = isWisejus ? 'wjs_...' : 'dgn_...';
    const apiKeyHelp = isWisejus
      ? 'Gere em WiseJus → Settings → API Keys (preset: full_admin)'
      : 'Gere em DocuGen → Settings → API Keys (preset: full_admin)';

    return (
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-secondary-700">Configuração {productLabel}</h4>
        <div>
          <label className="block text-sm font-medium text-secondary-600 mb-1">URL Base</label>
          <input
            type="url"
            value={config.baseUrl || ''}
            onChange={(e) => set('baseUrl', e.target.value)}
            placeholder={baseUrlPlaceholder}
            className="w-full rounded-lg border border-secondary-300 px-3 py-2 text-sm focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-secondary-600 mb-1">API Key</label>
          <input
            type="password"
            value={config.apiKey || ''}
            onChange={(e) => set('apiKey', e.target.value)}
            placeholder={isEditing ? 'Deixe vazio para manter a atual' : apiKeyPlaceholder}
            className="w-full rounded-lg border border-secondary-300 px-3 py-2 text-sm font-mono focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
          />
          <p className="text-xs text-secondary-400 mt-1">{apiKeyHelp}</p>
        </div>
      </div>
    );
  }

  return <p className="text-sm text-secondary-500">Selecione um tipo de integração</p>;
}
